import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { API } from "@/lib/api";

export default function PaymentSuccessPage() {
  const [status, setStatus] = useState('checking');
  const { refreshUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkPayment = async () => {
      const params = new URLSearchParams(window.location.search);
      const sessionId = params.get('session_id');
      
      if (!sessionId) {
        setStatus('error');
        return;
      }

      let attempts = 0;
      const maxAttempts = 5;

      const poll = async () => {
        try {
          const { data } = await API.get(`/payment/status/${sessionId}`);
          if (data.payment_status === 'paid') {
            setStatus('success');
            await refreshUser();
            setTimeout(() => navigate('/dashboard'), 2000);
          } else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(poll, 2000);
          } else {
            setStatus('pending');
          }
        } catch {
          setStatus('error');
        }
      };

      poll();
    };

    checkPayment();
  }, [refreshUser, navigate]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        {status === 'checking' && (
          <>
            <div className="w-16 h-16 border-4 border-[#A0655A] border-t-transparent rounded-full animate-spin mx-auto mb-6" />
            <h1 className="heading-font text-2xl font-medium text-[#111111] mb-2">Bekräftar betalning...</h1>
            <p className="text-[#111111]">Vänta medan vi verifierar din betalning.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Check className="text-green-600" size={32} />
            </div>
            <h1 className="heading-font text-2xl font-medium text-[#111111] mb-2">Tack för ditt köp!</h1>
            <p className="text-[#111111]">Du har nu tillgång till hela metoden. Du skickas vidare...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 className="heading-font text-2xl font-medium text-[#111111] mb-2">Något gick fel</h1>
            <p className="text-[#111111] mb-6">Vi kunde inte verifiera din betalning. Kontakta oss om problemet kvarstår.</p>
            <Button onClick={() => navigate('/')} className="bg-[#A0655A] hover:bg-[#8B5549] text-white rounded-full">
              Tillbaka till startsidan
            </Button>
          </>
        )}
        {status === 'pending' && (
          <>
            <h1 className="heading-font text-2xl font-medium text-[#111111] mb-2">Betalning behandlas</h1>
            <p className="text-[#111111] mb-6">Din betalning behandlas fortfarande. Du får ett mail när den är klar.</p>
            <Button onClick={() => navigate('/')} className="bg-[#A0655A] hover:bg-[#8B5549] text-white rounded-full">
              Tillbaka till startsidan
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
